/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

//PRODUCT: Modal info slider

let infoIcon = document.querySelector(".product-form__option-icon");
let infoPopup = document.querySelector(".product-modal");
let infoContainer = document.querySelector(".product-modal__content");
let closeIcon = document.querySelector(".product-modal__close-icon");

// adding a click event to all the buttons
if(infoIcon) {
  infoIcon.addEventListener("click", toggleSlider);
}

if(closeIcon) {
  closeIcon.addEventListener("click", toggleSlider);
}

if(infoPopup) {
  infoPopup.addEventListener("click", (e) => {
    if (!e.target.closest(".product-modal__content")) {
      toggleSlider();
    }
  });
}

function toggleSlider() {
  if (infoPopup.classList.contains("show")) {
    infoContainer.classList.toggle("slidein");
    setTimeout(() => {
      infoPopup.classList.toggle("show");
    }, 200);
  } else {
    infoPopup.classList.toggle("show");
    setTimeout(() => {
      infoContainer.classList.toggle("slidein");
    }, 200);
  }
}

// Dynamically adapt origin and CO2 messages
(function() {
  class DisplayHandler {
  constructor(containerId, messageId) {
    this.container = document.getElementById(containerId);
    this.messageElement = document.getElementById(messageId);
    if (!this.container || !this.messageElement) return;
    
    this.loadDataAttributes();
    this.updateDisplay(window.Product?.currentVariant);

    document.addEventListener('variant:changed', (event) => {
      if (event.detail?.variant) {
        this.updateDisplay(event.detail.variant);
      }
    });
  }
  
  loadDataAttributes() {
    // This method will be overridden in child classes
  }
  
  updateDisplay(variant) {
    // This method will be overridden in child classes
  }
}

// Handler for CO2 message display
class CO2DisplayHandler extends DisplayHandler {
  constructor() {
    super('co2-info-container', 'co2-message');
  }
  
  loadDataAttributes() {
    this.multiplier = parseFloat(this.container.dataset.co2Multiplier) || 2.37;
    this.textTemplate = this.container.dataset.textTemplate || '';
  }
  
  updateDisplay(variant) {
    console.log(variant);
    if (!variant) return;

    this.container.style.display = variant.is_new ? 'none' : '';
    
    if (!variant.is_new && variant.weight) {
      const carbonGain = Math.round(variant.weight * this.multiplier);
      this.messageElement.textContent = `${carbonGain}${this.textTemplate}`;
    }
  }
}

// Handler for origin message display
class OriginDisplayHandler extends DisplayHandler {
  constructor() {
    super('origin-info-container', 'origin-message');
  }
  
  loadDataAttributes() {
    this.newMessage = this.container.dataset.newMessage;
    this.usedMessage = this.container.dataset.usedMessage;
  }
  
  updateDisplay(variant) {
    if (!variant) return;
    
    this.messageElement.textContent = variant.is_new 
      ? this.newMessage 
      : this.usedMessage;
  }
}

// Initialize after DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  [
    CO2DisplayHandler,
    OriginDisplayHandler
  ].forEach(Handler => new Handler());
});
})();
